import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api";
import { toast } from "sonner";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dl_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  const [checkingOut, setCheckingOut] = useState(false);

  useEffect(() => {
    localStorage.setItem("dl_cart", JSON.stringify(items));
  }, [items]);

  const add = (product) => {
    setItems((prev) => {
      if (prev.find((i) => i.id === product.id)) return prev;
      return [...prev, { id: product.id, title: product.title, author: product.author, price: product.price, format: product.format, cover_image: product.cover_image || null }];
    });
    toast.success(`Dodano „${product.title}" do koszyka`);
  };

  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const count = items.length;
  const total = items.reduce((s, i) => s + i.price, 0);

  const checkout = async (form) => {
    if (!items.length) return null;
    setCheckingOut(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        items: items.map((i) => ({ product_id: i.id, quantity: 1 })),
        email: form.email,
        name: form.name,
        phone: form.phone,
        street: form.street,
        postal_code: form.postalCode,
        city: form.city,
        company_name: form.companyName || "",
        nip: form.nip || "",
        origin_url: window.location.origin,
        payment_method: form.method,
      });
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
        return data;
      }
      clear();
      return data;
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Nie udało się złożyć zamówienia. Spróbuj ponownie.");
      return null;
    } finally {
      setCheckingOut(false);
    }
  };

  return (
    <CartContext.Provider value={{ items, add, remove, clear, count, total, open, setOpen, checkout, checkingOut }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
